import axios from "axios";

export const OdealLeadGETALL = ({ generalToken, statusFilter }) => {
  return (dispatch) => {
    const HEADER = {
      headers: {
        authorization: "Bearer " + generalToken,
      },
      params: { status: statusFilter || "ALL" },
    };

    dispatch({
      type: "ODEAL_LEAD_GET_ALL",
      payload: axios
        .get("/api/OdealLead/Get", HEADER)
        .then((response) => response.data),
    });
  };
};

export const OdealLeadSYNCALL = ({ generalToken }) => {
  return (dispatch) => {
    const HEADER = {
      headers: {
        authorization: "Bearer " + generalToken,
      },
    };

    dispatch({
      type: "ODEAL_LEAD_SYNC_ALL",
      payload: axios
        .post("/api/OdealLead/SyncAll", null, HEADER)
        .then((response) => response.data),
    });
  };
};

export const OdealLeadSYNCONE = ({ generalToken, refCode }) => {
  return (dispatch) => {
    const HEADER = {
      headers: {
        authorization: "Bearer " + generalToken,
      },
      params: { refCode },
    };

    dispatch({
      type: "ODEAL_LEAD_SYNC_ONE",
      payload: axios
        .put("/api/OdealLead/Sync", null, HEADER)
        .then((response) => response.data),
    });
  };
};

export const OdealLeadSYNCSTALE = ({ generalToken, staleHours = 24, statuses = "INPROGRESS,UNKNOWN" }) => {
  return (dispatch) => {
    const HEADER = {
      headers: {
        authorization: "Bearer " + generalToken,
      },
      params: { staleHours, statuses },
    };

    dispatch({
      type: "ODEAL_LEAD_SYNC_STALE",
      payload: axios
        .post("/api/OdealLead/SyncStale", null, HEADER)
        .then((response) => response.data),
    });
  };
};

export const OdealLeadSUBMIT = ({ generalToken, lead }) => {
  return (dispatch) => {
    const HEADER = {
      headers: {
        authorization: "Bearer " + generalToken,
        "Content-Type": "application/json",
      },
    };

    dispatch({
      type: "ODEAL_LEAD_SUBMIT",
      payload: axios
        .post("/api/OdealLead/Submit", lead, HEADER)
        .then((response) => response.data),
    });
  };
};

export const OdealLeadPULLBYREF = ({ generalToken, refCode }) => {
  return (dispatch) => {
    const HEADER = {
      headers: {
        authorization: "Bearer " + generalToken,
      },
      params: { refCode },
    };

    dispatch({
      type: "ODEAL_LEAD_PULL_BY_REF",
      payload: axios
        .post("/api/OdealLead/PullByRef", null, HEADER)
        .then((response) => response.data),
    });
  };
};

export const OdealLeadPULLBULK = ({ generalToken, refCodes }) => {
  return (dispatch) => {
    const HEADER = {
      headers: {
        authorization: "Bearer " + generalToken,
      },
    };

    dispatch({
      type: "ODEAL_LEAD_PULL_BY_REF",
      payload: axios
        .post("/api/OdealLead/PullByRefBulk", { refCodes }, HEADER)
        .then((response) => response.data),
    });
  };
};

export const OdealLeadIMPORTCSV = ({ generalToken, file }) => {
  return (dispatch) => {
    const form = new FormData();
    form.append("file", file);
    const HEADER = {
      headers: {
        authorization: "Bearer " + generalToken,
        "Content-Type": "multipart/form-data",
      },
    };

    dispatch({
      type: "ODEAL_LEAD_IMPORT_CSV",
      payload: axios
        .post("/api/OdealLead/ImportPartnerCsv", form, HEADER)
        .then((response) => response.data),
    });
  };
};
